// src/components/relatorios/TabelaPerformanceComissao.js
import React from 'react';

const fmt = (v) => new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(v || 0);

function TabelaExecucao({ data, totais }) {
  if (!data || data.length === 0) return <div className="tabela-vazia">Nenhum dado disponível</div>;
  return (
    <div className="tabela-performance">
      <table className="tabela-relatorio">
        <thead>
          <tr>
            <th>#</th>
            <th>Técnico</th>
            <th>OS Faturadas</th>
            <th>Valor Total</th>
            <th>Ticket Médio</th>
            <th>Serviços Faturados</th>
            <th>Lucro Líquido</th>
            <th>Comissão (8%)</th>
          </tr>
        </thead>
        <tbody>
          {data.map((row, i) => (
            <tr key={i} className={i === 0 ? 'linha-destaque' : ''}>
              <td>{i===0?'🥇':i===1?'🥈':i===2?'🥉':`${i+1}º`}</td>
              <td><strong>{row.tecnico_nome}</strong></td>
              <td>{row.os_faturadas}</td>
              <td className="destaque-valor">{fmt(row.valor_total_faturado)}</td>
              <td>{fmt(row.ticket_medio)}</td>
              <td>{fmt(row.servicos_faturados)}</td>
              <td>{fmt(row.lucro_liquido)}</td>
              <td style={{color:'#2ecc71',fontWeight:'bold'}}>{fmt(row.comissionamento)}</td>
            </tr>
          ))}
        </tbody>
        {totais && (
          <tfoot>
            <tr className="linha-total">
              <td colSpan="2"><strong>TOTAL</strong></td>
              <td><strong>{totais.os_faturadas}</strong></td>
              <td><strong>{fmt(totais.valor_total_faturado)}</strong></td>
              <td></td>
              <td><strong>{fmt(totais.servicos_faturados)}</strong></td>
              <td><strong>{fmt(totais.lucro_liquido)}</strong></td>
              <td style={{color:'#2ecc71',fontWeight:'bold'}}><strong>{fmt(totais.comissionamento)}</strong></td>
            </tr>
          </tfoot>
        )}
      </table>
    </div>
  );
}

function TabelaVendas({ data, totais }) {
  if (!data || data.length === 0) return <div className="tabela-vazia">Nenhum dado disponível</div>;
  return (
    <div className="tabela-performance">
      <table className="tabela-relatorio">
        <thead>
          <tr>
            <th>#</th>
            <th>Vendedor</th>
            <th>OS Faturadas</th>
            <th>Valor Total</th>
            <th>Ticket Médio</th>
            <th>Produtos Faturados</th>
            <th>Lucro Líquido</th>
            <th>Comissão (5%)</th>
          </tr>
        </thead>
        <tbody>
          {data.map((row, i) => (
            <tr key={i} className={i === 0 ? 'linha-destaque' : ''}>
              <td>{i===0?'🥇':i===1?'🥈':i===2?'🥉':`${i+1}º`}</td>
              <td><strong>{row.vendedor_nome}</strong></td>
              <td>{row.os_faturadas}</td>
              <td className="destaque-valor">{fmt(row.valor_total_faturado)}</td>
              <td>{fmt(row.ticket_medio)}</td>
              <td>{fmt(row.produtos_faturados)}</td>
              <td>{fmt(row.lucro_liquido)}</td>
              <td style={{color:'#3498db',fontWeight:'bold'}}>{fmt(row.comissionamento)}</td>
            </tr>
          ))}
        </tbody>
        {totais && (
          <tfoot>
            <tr className="linha-total">
              <td colSpan="2"><strong>TOTAL</strong></td>
              <td><strong>{totais.os_faturadas}</strong></td>
              <td><strong>{fmt(totais.valor_total_faturado)}</strong></td>
              <td></td>
              <td><strong>{fmt(totais.produtos_faturados)}</strong></td>
              <td><strong>{fmt(totais.lucro_liquido)}</strong></td>
              <td style={{color:'#3498db',fontWeight:'bold'}}><strong>{fmt(totais.comissionamento)}</strong></td>
            </tr>
          </tfoot>
        )}
      </table>
    </div>
  );
}

function TabelaConsolidado({ execucao, vendas, totais }) {
  if (!execucao || !vendas) return null;
  return (
    <div className="tabela-performance">
      <table className="tabela-relatorio">
        <thead>
          <tr>
            <th>Tipo</th>
            <th>Nome</th>
            <th>OS Faturadas</th>
            <th>Valor Total</th>
            <th>Serviços</th>
            <th>Produtos</th>
            <th>Lucro Líquido</th>
            <th>Comissão</th>
            <th>%</th>
          </tr>
        </thead>
        <tbody>
          {execucao.map((row, i) => (
            <tr key={'e'+i} style={{background: i%2===0?'rgba(46,204,113,0.05)':''}}>
              <td><span style={{background:'#2ecc71',color:'#fff',padding:'2px 8px',borderRadius:4,fontSize:11}}>Técnico</span></td>
              <td><strong>{row.nome}</strong></td>
              <td>{row.os_faturadas}</td>
              <td>{fmt(row.valor_total_faturado)}</td>
              <td>{fmt(row.servicos_faturados)}</td>
              <td>{fmt(row.produtos_faturados)}</td>
              <td>{fmt(row.lucro_liquido)}</td>
              <td style={{color:'#2ecc71',fontWeight:'bold'}}>{fmt(row.comissionamento)}</td>
              <td>{row.percentual_comissao}%</td>
            </tr>
          ))}
          {vendas.map((row, i) => (
            <tr key={'v'+i} style={{background: i%2===0?'rgba(52,152,219,0.05)':''}}>
              <td><span style={{background:'#3498db',color:'#fff',padding:'2px 8px',borderRadius:4,fontSize:11}}>Vendedor</span></td>
              <td><strong>{row.nome}</strong></td>
              <td>{row.os_faturadas}</td>
              <td>{fmt(row.valor_total_faturado)}</td>
              <td>{fmt(row.servicos_faturados)}</td>
              <td>{fmt(row.produtos_faturados)}</td>
              <td>{fmt(row.lucro_liquido)}</td>
              <td style={{color:'#3498db',fontWeight:'bold'}}>{fmt(row.comissionamento)}</td>
              <td>{row.percentual_comissao}%</td>
            </tr>
          ))}
        </tbody>
        {totais && (
          <tfoot>
            <tr className="linha-total">
              <td colSpan="2"><strong>TOTAL GERAL</strong></td>
              <td colSpan="4"></td>
              <td><strong>{fmt(totais.total_lucro_liquido_execucao + totais.total_lucro_liquido_vendas)}</strong></td>
              <td style={{color:'#e74c3c',fontWeight:'bold'}}><strong>{fmt(totais.total_comissionamento)}</strong></td>
              <td></td>
            </tr>
            <tr>
              <td colSpan="6" style={{textAlign:'right',fontSize:12,color:'#666'}}>Comissão Execução (8%):</td>
              <td colSpan="3" style={{color:'#2ecc71',fontWeight:'bold'}}>{fmt(totais.total_comissionamento_execucao)}</td>
            </tr>
            <tr>
              <td colSpan="6" style={{textAlign:'right',fontSize:12,color:'#666'}}>Comissão Vendas (5%):</td>
              <td colSpan="3" style={{color:'#3498db',fontWeight:'bold'}}>{fmt(totais.total_comissionamento_vendas)}</td>
            </tr>
          </tfoot>
        )}
      </table>
    </div>
  );
}


function TabelaPagamentos({ pagamentos }) {
  if (!pagamentos || pagamentos.length === 0) return null;
  const fmt = (v) => new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(v || 0);
  const total = pagamentos.reduce((s,r) => s + r.total, 0);
  return (
    <div style={{marginTop: 24, background: 'var(--bg-card, #1a1a2e)', borderRadius: 12, overflow: 'hidden', border: '1px solid var(--border, #333)'}}>
      <div style={{padding: '16px 20px', background: 'linear-gradient(135deg, #e74c3c, #c0392b)', color: '#fff'}}>
        <h4 style={{margin: 0, fontSize: 16}}>💰 Resumo de Pagamentos de Comissão</h4>
        <p style={{margin: '4px 0 0', fontSize: 12, opacity: 0.85}}>Total a pagar: {fmt(total)}</p>
      </div>
      <table style={{width:'100%', borderCollapse:'collapse'}}>
        <thead>
          <tr style={{background:'rgba(255,255,255,0.05)'}}>
            <th style={{padding:'10px 16px', textAlign:'left', fontSize:13}}>Pessoa</th>
            <th style={{padding:'10px 16px', textAlign:'right', fontSize:13, color:'#2ecc71'}}>Comissão Execução (8%)</th>
            <th style={{padding:'10px 16px', textAlign:'right', fontSize:13, color:'#3498db'}}>Comissão Vendas (5%)</th>
            <th style={{padding:'10px 16px', textAlign:'right', fontSize:13, color:'#e74c3c', fontWeight:'bold'}}>Total a Pagar</th>
          </tr>
        </thead>
        <tbody>
          {pagamentos.filter(p => p.total > 0).map((p, i) => (
            <tr key={i} style={{borderTop:'1px solid var(--border, #333)'}}>
              <td style={{padding:'12px 16px', fontWeight:'bold'}}>{p.nome}</td>
              <td style={{padding:'12px 16px', textAlign:'right', color:'#2ecc71'}}>{fmt(p.comissao_execucao)}</td>
              <td style={{padding:'12px 16px', textAlign:'right', color:'#3498db'}}>{fmt(p.comissao_vendas)}</td>
              <td style={{padding:'12px 16px', textAlign:'right', color:'#e74c3c', fontWeight:'bold', fontSize:15}}>{fmt(p.total)}</td>
            </tr>
          ))}
        </tbody>
        <tfoot>
          <tr style={{borderTop:'2px solid var(--border, #444)', background:'rgba(231,76,60,0.1)'}}>
            <td colSpan="3" style={{padding:'12px 16px', fontWeight:'bold'}}>TOTAL GERAL A PAGAR</td>
            <td style={{padding:'12px 16px', textAlign:'right', color:'#e74c3c', fontWeight:'bold', fontSize:16}}>{fmt(total)}</td>
          </tr>
        </tfoot>
      </table>
    </div>
  );
}

export { TabelaExecucao, TabelaVendas, TabelaConsolidado, TabelaPagamentos };
